import { Pipe, PipeTransform } from '@angular/core';

interface SearchPipeItem {
  name?: string;
  lastMessage?: string;
  text?: string;
}

@Pipe({
  name: 'SearchPipe',
  pure: false,
  standalone: false,
})
export class SearchPipe implements PipeTransform {
  transform(
    value: SearchPipeItem[] | undefined,
    args?: string
  ): SearchPipeItem[] | undefined {
    const searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter((conversation) => {
        if (conversation.name) {
          return (
            conversation.name.search(searchText) !== -1 ||
            conversation.lastMessage.search(searchText) !== -1
          );
        } else {
          if (conversation.text) {
            return conversation.text.search(searchText) !== -1;
          }
        }
      });
    }
  }
}
